import { render, staticRenderFns } from "./DocumentsB2B.vue?vue&type=template&id=7f3f8a9e&"
import script from "./DocumentsB2B.vue?vue&type=script&lang=js&"
export * from "./DocumentsB2B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports